import React, { useEffect, useState } from 'react';
import "./Sidebar.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { handleSubMenuSelection, handleMenuSelection } from '../../utils/utils';
import { useNavigate } from 'react-router-dom';



const Sidebar = () => {
    const dispatch = useDispatch();
    const states = useSelector((state) => state, shallowEqual);
    const navigate = useNavigate();
    useEffect(() => {

    }, [states?.settingsMenu, states?.menu])

    return (

        <div className="sidebar-wrapper sidebar-theme">

            <nav id="sidebar">
                <ul className="list-unstyled menu-categories ps" id="accordionExample">
                    {states?.userInfo?.isAdmin === 0 && <li className="menu" onClick={() => handleMenuSelection("dashboard", dispatch, states)}>
                        <a  onClick={() => navigate("/dashboard")}
                            data-active={states.menu?.dashboard} aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                                <span>Tableau de bord</span>
                            </div>

                        </a>
                    </li>}
                    { states.userPermissions?.list_transmission !== undefined && <li className="menu" onClick={() => handleMenuSelection("transmission", dispatch, states)}>
                        <a    onClick={() => navigate("/transmission")}
                            data-active={states.menu?.transmission} aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-cpu"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>
                                <span>Transmission</span>
                            </div>
                        </a>
                    </li>}

                    {/* Start Monitoring */}
                    { (states.userPermissions?.follow_transmission !== undefined && states.userPermissions.follow_taux !== undefined) && <li className="menu" onClick={() => handleMenuSelection("monitoring", dispatch, states)}>
                        <a href="" data-active={states.menu?.monitoring} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-airplay"><path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon></svg>
                                <span>Suivi</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
                            </div>
                        </a>
                        <ul className={states?.menu?.monitoring == true ? "collapse submenu list-unstyled show" : "collapse submenu list-unstyled"} id="app" data-parent="#accordionExample">
                            <li className={states?.suiviMenu?.suiviTaux} onClick={() => handleSubMenuSelection("suivi-taux", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/suivi-taux")}
                                   > Taux </a>
                            </li>

                            <li className={states?.suiviMenu?.suiviTransmission} onClick={() => handleSubMenuSelection("suivi-transmission", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/suivi-transmission")}
                                > Transmission </a>
                            </li>


                        </ul>
                    </li>}
                    {/* End Monitoring */}

                    

                    {/* <li className="menu" onClick={() => handleMenuSelection("reports", dispatch, states)}>
                        <a onClick={() => navigate("/reports")} data-active={states.menu?.reports} aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-clipboard"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg>
                                <span>Rapports</span>
                            </div>
                        </a>
                    </li> */}

                    {(states.userPermissions?.list_product !== undefined||
                      states.userPermissions?.list_category_product !== undefined ||
                      states.userPermissions?.list_institution !== undefined ||
                      states.userPermissions?.list_category_institution !== undefined ||
                      states.userPermissions?.list_user !== undefined ||
                      states.userPermissions?.list_role !== undefined ||
                      states.userPermissions?.list_configuration !== undefined ||
                      states.userPermissions?.view_journal !== undefined) && <li className="menu" onClick={() => handleMenuSelection("settings", dispatch, states)}>
                        <a href="" data-active={states.menu?.settings} data-toggle="collapse" aria-expanded="false" className="dropdown-toggle">
                            <div className="">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-box"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                                <span>Paramètres</span>
                            </div>
                            <div>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-chevron-right"><polyline points="9 18 15 12 9 6"></polyline></svg>
                            </div>
                        </a>
                        <ul style={{ overflowY: "scroll", height: "250px" }} className={states.menu?.settings == true ? "collapse submenu list-unstyled show" : "collapse submenu list-unstyled"} id="app" data-parent="#accordionExample">
                            {states.userPermissions?.list_product !== undefined && <li className={states?.settingsMenu?.products} onClick={() => handleSubMenuSelection("products", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/product")}
                                > Produits </a>
                            </li>}
                            {/* Start Calcul TEG */}
                            {0 !== 1 && <li className={states?.settingsMenu?.calculTeg} onClick={() => handleSubMenuSelection("calculTeg", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/calcul-teg")}
                                > Calcul TEG </a>
                            </li>}
                            {/* End Calcul TEG */}
                            { states.userPermissions?.list_category_product !== undefined && <li className={states?.settingsMenu?.productsCategories} onClick={() => handleSubMenuSelection("products-categories", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/product-category")}
                                > Catégories de produit </a>
                            </li>}
                           { states.userPermissions?.list_institution !== undefined && <li className={states?.settingsMenu?.institutions} onClick={() => handleSubMenuSelection("institutions", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/institution")}
                                > Institutions </a>
                            </li>}

                            { states.userPermissions?.list_category_institution !== undefined && <li className={states?.settingsMenu?.institutionsCategories} onClick={() => handleSubMenuSelection("institutions-categories", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/institution-category")}
                                > Catégories d'institution </a>
                            </li>}

                            { states.userPermissions?.list_user !== undefined && <li className={states?.settingsMenu?.users} onClick={() => handleSubMenuSelection("users", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/agent")}
                                > Agents </a>
                            </li>}
                            { states.userPermissions?.list_role !== undefined && <li className={states?.settingsMenu?.roles} onClick={() => handleSubMenuSelection("roles", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/role")}
                                > Rôles </a>
                            </li>}

                            { states.userPermissions?.list_zone !== undefined &&  <li className={states?.settingsMenu?.zones} onClick={() => handleSubMenuSelection("zones", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/zone")}
                                > Zones </a>
                            </li>}

                           { states.userPermissions?.list_configuration !== undefined && states.userPermissions?.update_configuration !== undefined && <li className={states?.settingsMenu?.alertes} onClick={() => handleSubMenuSelection("alertes", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/alertes")}
                                >Configuration des alertes </a>
                            </li>}

                           { states.userPermissions?.view_journal !== undefined && <li className={states?.settingsMenu?.logs} onClick={() => handleSubMenuSelection("logs", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/logs")}
                                > Journal des évènements </a>
                            </li>}

                            {/* { states.userPermissions?.webgate_configuration !== undefined &&  */}
                            { states.userPermissions?.show_portail_web !== undefined && 
                            <li className={states?.settingsMenu?.webgate} onClick={() => handleSubMenuSelection("webgate", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/portail-web")}
                                > Portail Web</a>
                                </li>}

                                {/* { states.userPermissions?.show_portail_web !== undefined &&  */}
                            {/* <li className={states?.settingsMenu?.configuration} onClick={() => handleSubMenuSelection("configuration", dispatch)}>
                                <a className="sidebar-submenu" 
                                onClick={() => navigate("/configuration")}
                                > Configuration</a>
                                </li> */}
                                {/* } */}
            
                        </ul>
                    </li>}





                </ul>

            </nav>

        </div>
    )
}

export default Sidebar
